var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9938 6.26063C13.0152 6.7102 12.8944 7.1551 12.6483 7.532C12.4023 7.9089 12.0437 8.1986 11.6235 8.35988C11.6235 8.35988 12.1927 7.79737 12.1663 6.35569C12.1393 4.914 11.0807 4.20131 11.0807 4.20131C11.0807 4.20131 12.9673 4.6215 12.9932 6.26006L12.9938 6.26063ZM6.714 13.9607L4.78125 14.0558V13.8752C4.78125 13.8752 5.96419 13.7531 5.96419 11.6308V6.20831C5.96419 4.41169 4.78125 4.10062 4.78125 4.10062V3.9375L6.714 4.032V13.9607ZM9.80325 14.0619C8.96231 14.0693 7.4025 13.9517 7.4025 13.9517V4.04606C8.43075 4.032 8.79019 3.89025 9.63731 4.01231C10.485 4.13381 11.2129 4.98038 11.4114 5.82694C11.61 6.6735 11.3985 7.47956 11.1268 7.91944C10.8551 8.35931 10.26 8.66475 10.26 8.66475C10.26 8.66475 11.16 8.97637 11.4778 9.24694C11.7956 9.51806 12.4116 10.2561 12.1731 11.8614C11.9346 13.4668 10.6436 14.0552 9.80325 14.0619ZM12.0369 13.6963C12.0369 13.6963 12.9538 12.8976 12.9133 11.277C12.8728 9.65644 12.0369 8.89481 12.0369 8.89481C12.0369 8.89481 13.7616 9.32794 13.7807 11.2584C13.8009 13.1884 12.0369 13.6963 12.0369 13.6963ZM10.2932 7.88344C10.9108 7.06163 10.7168 5.51531 9.96863 4.98656C9.2205 4.45781 8.433 4.72219 8.28113 4.87125C8.12812 5.02031 8.13487 8.48812 8.13487 8.48812C8.13487 8.48812 9.67556 8.70525 10.2932 7.88344ZM10.4074 9.36C9.82913 9.10237 8.13487 9.16988 8.13487 9.16988C8.13487 9.16988 8.10844 10.0457 8.17031 11.6848C8.23219 13.3239 8.7795 13.3149 9.34875 13.3374C9.918 13.3599 11.0036 13.3194 11.3608 11.9059C11.7186 10.4929 10.9856 9.61706 10.4074 9.36Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlk);
export default __webpack_public_path__ + "static/media/blk.7e54aab74cb25a69aa8a3427edb24de1.svg";
export { ForwardRef as ReactComponent };